import { ConfigurationName } from '../../../enums/ConfigurationName';

/**
 * Settings whose stored value is composed rather than scalar. The generic value editor cannot
 * represent them, so the table shows a summary and routes editing to a specialist dialog. The
 * definition still decides visibility, scope, ownership and permission for these settings.
 */
export const SPECIALIST_EDITOR_NAMES: readonly string[] = [
  ConfigurationName[ConfigurationName.PosIntegration],
];

export const hasSpecialistEditor = (name: string): boolean => SPECIALIST_EDITOR_NAMES.includes(name);
